import React from 'react'
import Image from 'react-bootstrap/Image';

function LogoQualy(props) {
    return (
        <div className={props.className}>
            <Image src='/static/images/logo_qualy.png' className='w-50' />
        </div>
    )
}

export default LogoQualy